<template>
  <div class="bj-section">
    <div class="link-warp">
      <div
        :class="['link-item', { active: item.value === $route.path }]"
        v-for="item in navList"
        :key="item.value"
        @click="onClick(item.value)">
        {{ item.label }}
      </div>
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "pushcontainer",
  data() {
    return {
      navList: [
        {
          active: true,
          value: "/my/push",
          label: "域名PUSH",
        },
        {
          active: false,
          value: "/my/push/receive",
          label: "收到的请求",
        },
        {
          active: false,
          value: "/my/push/sent",
          label: "发出的请求",
        },
      ],
    };
  },
  methods: {
    onClick(val) {
      this.$router.push(val);
    },
  },
};
</script>

<style lang="less" scoped>
.link-warp {
  position: relative;
  .link-item {
    display: inline-block;
    height: 60px;
    line-height: 60px;
    margin: 0 30px;
    color: #fff;
    font-size: 20px;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    &:first-child{
      margin-left: 0;
    }
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      width: 0;
      height: 3px;
      background-color: transparent;
      transition: all 0.3s;
    }
  }
  .link-item.active {
    color: #F85A36;
  }
  .goback {
    position: absolute;
    top: 50%;
    right: 60px;
    transform: translateY(-50%);
  }
}
</style>
